import PropTypes from 'prop-types';
import { intlMessageShape } from './intlMessageShape';
export var sideContentPropTypes = {
  label: intlMessageShape.isRequired,
  icon: PropTypes.string,
  component: PropTypes.elementType.isRequired,
  componentProps: PropTypes.shape({})
};
export var sideContentShape = PropTypes.shape(sideContentPropTypes);